import { getUid } from '@tencent/docs-login';
import {
    ISlideRenderStateManager, IStatePointEnum,
} from '@src/slide/application/service/slide-render-state/slide-render-state-manager.interface';

/**
 * 提供 浏览器与腾讯文档桌面端App 交互能力
 */
export default class TencentDocsAppService {
    public constructor(private slideRenderStateManager: ISlideRenderStateManager) {
        this.init();
    }

    private init() {
        this.slideRenderStateManager.getStatePoints()[IStatePointEnum.visibleSlideRender].getPointCompletePromise()
            .then(() => {
                this.openDocInElectron();
            });
    }

    /** 通知客户端打开弹窗 */
    private async openDocInElectron() {
        import('@tencent/docs-electron-client').then(({ default: DocsElectronClient }) => {
            const docsElectronClient = new DocsElectronClient();
            docsElectronClient.openDocInElectron({
                docUrl: location.href,
                uid: getUid() || '',
            });
        });
    }
}
